import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";

export const asyncRoutes: Array<RouteRecordRaw> = [
  /**
   * 概览
   */
  {
    path: "index",
    name: "index",
    component: () => import("../views/survey/Index.vue"),
    meta: {
      title: "概览",
    },
  },
  /**
   * 试用列表
   */
  {
    path: "app",
    name: "app",
    component: () => import("../views/appList/Index.vue"),
    meta: {
      title: "应用列表",
    },
    children: [
      {
        path: "trial",
        name: "trial",
        component: () => import("../views/appList/trial/Index.vue"),
        meta: {
          title: "试用列表",
        },
      },
      {
        path: "trial/:id",
        name: "trialDetail",
        component: () => import("../views/appList/components/detail.vue"),
        props: true,
        meta: {
          hidden: true,
        },
      },
      {
        path: "official",
        name: "official",
        component: () => import("../views/appList/official/Index.vue"),
        meta: {
          title: "正式列表",
        },
      },
      {
        path: "official/:id",
        name: "officialDetail",
        component: () => import("../views/appList/components/detail.vue"),
        props: true,
        meta: {
          hidden: true,
        },
      },
    ],
  },
  /**
   * 解决方案
   */
  {
    path: "solution",
    name: "solution",
    component: () => import("../views/solutionList/Index.vue"),
    meta: {
      title: "解决方案",
    },
  },
  /**
   * 解决方案详情
   */
  {
    path: "solution/:id",
    name: "solutionDetail",
    component: () => import("../views/solutionList/components/detail.vue"),
    props: true,
    meta: {
      hidden: true,
    },
  },
  /**
   * 数字人
   */
  {
    path: "meta-human",
    name: "metaHuman",
    component: () => import("../views/metaHuman/Index.vue"),
    meta: {
      title: "数字人",
    },
  },
  /**
   * 资源商店
   */
  {
    path: "resource",
    name: "resource",
    component: () => import("../views/assetStore/Index.vue"),
    meta: {
      title: "数字资产",
    },
    children: [
      {
        name: "outfit",
        path: "outfit",
        component: () => import("../views/assetStore/outfit/Index.vue"),
        meta: {
          title: "服饰",
        },
      },
      {
        name: "animation",
        path: "animation",
        component: () => import("../views/assetStore/animation/Index.vue"),
        meta: {
          title: "动作",
        },
      },
      {
        name: "emoticon",
        path: "emoticon",
        component: () => import("../views/assetStore/emoticon/Index.vue"),
        meta: {
          title: "表情",
        },
      },
      {
        name: "voice",
        path: "voice",
        component: () => import("../views/assetStore/voice/Index.vue"),
        meta: {
          title: "语音",
        },
      },
      {
        name: "template",
        path: "template",
        component: () => import("../views/assetStore/template/Index.vue"),
        meta: {
          title: "模板",
        },
      },
    ],
  },
];

export const myRoutes: Array<RouteRecordRaw> = [
  /**
   * 我的账户
   */
  {
    path: "account",
    name: "account",
    component: () => import("../views/my/Index.vue"),
    meta: {
      title: "我的账户",
    },
    children: [
      {
        path: "user",
        name: "user",
        component: () => import("../views/my/user/Index.vue"),
        meta: {
          title: "账号信息",
        },
      },
      {
        path: "assets",
        name: "assets",
        component: () => import("../views/my/assets/Index.vue"),
        meta: {
          title: "资产信息",
        },
        children: [
          {
            name: "outfits",
            path: "outfits",
            component: () => import("../views/my/assets/outfit/Index.vue"),
            meta: {
              title: "服饰",
            },
          },
          {
            name: "animations",
            path: "animations",
            component: () => import("../views/my/assets/animation/Index.vue"),
            meta: {
              title: "动作",
            },
          },
          {
            name: "emoticons",
            path: "emoticons",
            component: () => import("../views/my/assets/emoticon/Index.vue"),
            meta: {
              title: "表情",
            },
          },
          {
            name: "voices",
            path: "voices",
            component: () => import("../views/my/assets/voice/Index.vue"),
            meta: {
              title: "语音",
            },
          },
        ],
      },
      {
        path: "order",
        name: "order",
        component: () => import("../views/my/order/Index.vue"),
        meta: {
          title: "交易信息",
        },
      },
    ],
  },
  {
    path: "message",
    name: "message",
    component: () => import("../views/message/Index.vue"),
    meta: {
      title: "消息中心",
    },
    children: [
      {
        path: "notice",
        name: "notice",
        component: () => import("../views/message/notice/Index.vue"),
        meta: {
          title: "消息通知",
        },
      },
      {
        path: "notice/:id",
        name: "noticeDetail",
        component: () => import("../views/message/notice/components/detail.vue"),
        props: true,
        meta: {
          title: "消息通知详情",
          hidden: true,
        },
      },
      {
        path: "workOrder",
        name: "workOrder",
        component: () => import("../views/message/workOrder/Index.vue"),
        meta: {
          title: "问题反馈",
        },
      },
      {
        path: "workOrder/create",
        name: "workOrderCreate",
        component: () => import("../views/message/workOrder/components/create.vue"),
        meta: {
          title: "创建问题反馈",
          hidden: true,
        },
      },
      {
        path: "workOrder/:id",
        name: "workOrderDetail",
        component: () => import("../views/message/workOrder/components/detail.vue"),
        props: true,
        meta: {
          title: "问题反馈详情",
          hidden: true,
        },
      },
      {
        path: "setting",
        name: "setting",
        component: () => import("../views/message/setting/Index.vue"),
        meta: {
          title: "消息设置",
        },
      },
    ],
  },
];

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "index",
    component: () => import("../views/Index.vue"),
    redirect: "/index",
    children: asyncRoutes,
  },
  {
    path: "/my",
    name: "my",
    component: () => import("../views/Index.vue"),
    children: myRoutes,
  },
  {
    path: "/home",
    name: "home",
    component: () => import("../views/home/Index.vue"),
  },
  {
    path: "/h5Home",
    name: "h5Home",
    component: () => import("../views/h5Home/Index.vue"),
  },
  {
    path: "/createIdol",
    name: "createIdol",
    component: () => import("../views/createIdol/Index.vue"),
  },
  {
    path: "/idolEdit",
    name: "idolEdit",
    component: () => import("../views/createIdol/idolEdit.vue"),
  },
  {
    path: "/mobile-tip",
    name: "mobile-tip",
    component: () => import("../views/mobileTip/Index.vue"),
  },
  {
    path: "/:pathMatch(.*)",
    redirect: "/",
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes: routes,
});

export default router;
